export default __webpack_public_path__ + "static/media/19.b0b80468.png";